const navigation = {
    admin: '管理',
    anomalies: '不審行為一覧',
    activityDashboard: 'アクティビティダッシュボード',
    dashboard: 'ダッシュボード',
    documents: 'ドキュメント',
    search: '検索',
    uploadDocument: 'ドキュメントをアップロード',
    drbfm: 'DRBFM',
    verification: '設計検証項目',
    cadViewer: '3D CADビューア',
    settings: '設定',
    help: 'ヘルプ',
    profile: 'プロフィール',
    logout: 'ログアウト',
    logoutConfirm: {
      title: 'ログアウト',
      description: '保存されていない入力内容は失われます。ログアウトしてもよろしいですか？',
      confirm: 'ログアウト',
    },
    toggleSidebar: 'サイドバーを切り替え',
    workspaceSection: 'ワークスペース',
    toggleChat: 'AIチャットを切り替え',
    notifications: '通知',
    resizeChat: 'チャットパネルの幅を変更',
  };

export default navigation;
